<div mat-dialog-content>
    <p><b>Are you sure you want to Delete the Kaizen?</b></p>
</div>
<div mat-dialog-actions>
    <button mat-flat-button type="button" color="primary" [mat-dialog-close]="true">Yes</button>
    <button  mat-flat-button type="button" color="primary" [mat-dialog-close]="false">No</button>
</div>